export default __webpack_public_path__ + "static/media/miscellaneous-bg.8dfa7b5f.webp";